import { RegistrationStatusSectionCombinedProps } from './types';

const usePresenter = (props: RegistrationStatusSectionCombinedProps): RegistrationStatusSectionCombinedProps => {
  return props;
};

export default usePresenter;
